/**
 * Deduplicates a reaction list to at most one row per userId, keeping the
 * first occurrence (caller should sort DESC by CreatedDate so first = most recent).
 * Rows missing a userId pass through without deduplication.
 * CR-B3-04.
 */
export const deduplicateReactionsByUser = <T extends { userId?: string }>(
  reactions: T[],
): T[] => {
  const seen = new Set<string>();
  const result: T[] = [];
  for (const r of reactions) {
    const key = r.userId ?? '';
    if (!key) {
      result.push(r);
      continue;
    }
    if (!seen.has(key)) {
      seen.add(key);
      result.push(r);
    }
  }
  return result;
};
